module.exports = __webpack_public_path__ + "6ca6f75303397f2125abfa66dc9661a9.svg";